import React from 'react';
import { useVerificationWizard } from '../useVerificationWizard';
import AddressForm from '../../wizard/forms/AddressForm';
import VerificationStepActionBar from '../VerificationStepActionBar';
import { VERIFICATION_STEPS } from '../../../types/verification';
import '../../../pages/VerificationWizardPage.css';

const STEP = VERIFICATION_STEPS.ADDRESS;

const VerifyAddressStep: React.FC = () => {
  const {
    state,
    stepErrors,
    updateMailingAddress,
    updateShippingAddress,
    saveAddresses,
    markStepConfirmed,
    markStepSkipped,
    getStepStatus,
    isSaving,
  } = useVerificationWizard();

  const errors = stepErrors[STEP] || {};

  return (
    <div className="wizard-step">
      <h2>Verify Addresses</h2>
      <p className="step-description">Review and update the clinic's mailing and shipping addresses.</p>

      <div className="verify-section">
        <h3 className="verify-section-heading">
          Mailing Address
        </h3>
        <AddressForm
          values={state.mailingAddress}
          onChange={updateMailingAddress}
          errors={errors}
          idPrefix="mailing-"
        />
      </div>

      <div className="verify-section-divider">
        <h3 className="verify-section-heading">
          Shipping Address
        </h3>
        <AddressForm
          values={state.shippingAddress}
          onChange={updateShippingAddress}
          errors={{}}
          idPrefix="shipping-"
        />
      </div>

      <VerificationStepActionBar
        stepStatus={getStepStatus(STEP)}
        isSaving={isSaving}
        onSaveChanges={saveAddresses}
        onNoChanges={() => markStepConfirmed(STEP)}
        onSkip={(notes) => markStepSkipped(STEP, notes)}
      />
    </div>
  );
};

export default VerifyAddressStep;
